import { render, staticRenderFns } from "./ExpIntro.vue?vue&type=template&id=fe07af96&scoped=true&"
import script from "./ExpIntro.vue?vue&type=script&lang=js&"
export * from "./ExpIntro.vue?vue&type=script&lang=js&"
import style0 from "./ExpIntro.vue?vue&type=style&index=0&id=fe07af96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07af96",
  null
  
)

export default component.exports